import React from 'react'
import { Switch, Route } from 'react-router-dom'

import Loadable from 'src/utils/loadable'

const routes = () => {
  return (
    <Switch>
      <Route path='/user/notifications' component={Loadable(() => import('./Notifications'))} />
      <Route path='/user/profile' component={Loadable(() => import('./UserProfile'))} />
      <Route path='/user/add' component={Loadable(() => import('./UserAdd'))} />
      <Route path='/user/me' component={Loadable(() => import('./Profile'))} />
      <Route path='/users' component={Loadable(() => import('./UserList'))} />
    </Switch>
  )
}

export default routes
